import { render, staticRenderFns } from "./CardClient.vue?vue&type=template&id=611c29ba"
import script from "./CardClient.vue?vue&type=script&lang=js"
export * from "./CardClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports